if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      observer = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
           if(this.closest(".product-info-mobile")){
              this.remove();
              return;
          }
        this.initializeRecommendations(this.dataset.productId);
      }

      initializeRecommendations(productId) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations(productId);
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      loadRecommendations(productId) {
        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations?.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const fade = this.querySelectorAll('[data-animate-fade]');
              fade.forEach((element) => element.classList.remove('faded-out'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
